export default __webpack_public_path__ + "static/media/cetrioli.4e6c9d44.mp3";